import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'
import DropdownArrow from 'icons/dropdown-arrow.svg'

export const Wrapper = styled.div`
  position: relative;
  padding: ${calculateResponsiveSize(120)} 12vw;
  ${mediaMax('desktopSm')} {
    padding: 40px 5vw;
  }
  ${mediaMax('tabletLandscape')} {
    padding: 40px 20px 24px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: ${({ $direction }) =>
    $direction === 'row' ? `row` : 'column'};
  justify-content: space-between;
  margin-bottom: ${calculateResponsiveSize(60)};
  padding-bottom: ${calculateResponsiveSize(60)};
  border-bottom: ${calculateResponsiveSize(1)} solid #fff;
  ${mediaMax('tabletLandscape')} {
    flex-direction: column;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #fff;
  }
`

export const ColumnWrapper = styled.div`
  ${mediaMax('tabletLandscape')} {
    &:first-child {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #fff;
    }
  }
`

export const Column = styled.div`
  width: ${({ $length }) => ($length ? `calc(100% / ${$length})` : '100%')};
  ${mediaMax('tablet')} {
    width: 100%;
    &:first-child {
      padding-top: 20px;
    }
  }
`

export const List = styled.ul`
justify-content`

export const ListItem = styled.li`
  color: #fff;
  font-family: 'caslon', sans-serif;
  font-size: ${calculateResponsiveSize(21)};
  font-weight: 400;
  line-height: 1.6;
  white-space: break-spaces;

  ${mediaMax('tabletLandscape')} {
    font-size: 18px;
  }
`

export const Title = styled.div`
  margin-bottom: ${calculateResponsiveSize(30)};
  font-family: 'caslon', sans-serif;
  font-size: ${calculateResponsiveSize(48)};
  font-weight: 400;
  line-height: 1.25;
  color: #fff;
  width: ${({ $length }) => ($length > 1 ? `calc(100% / ${$length})` : '100%')};
  ${mediaMax('desktop')} {
    font-size: 48px;
  }
  ${mediaMax('tabletLandscape')} {
    font-size: 36px;
  }
  ${mediaMax('tablet')} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    font-size: 18px;
    font-family: 'proxima_nova_semibold', sans-serif;
    text-transform: uppercase;
    &:after {
      content: '';
      display: block;
      width: 7px;
      height: 12px;
      margin-left: 6px;
      background: url(${DropdownArrow}) no-repeat center;
      flex-shrink: 0;
      transform: ${({ $active }) => ($active ? 'rotate(90deg)' : '')};
    }
  }
`

export const Header = styled.header`
  display: flex;
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
  ${mediaMax('tabletLandscape')} {
    width: 100%;
    flex-direction: column;
  }
  ${mediaMax('tablet')} {
    height: auto;
    max-height: ${({ $active }) => ($active ? '1000px' : '0')};
    transition: max-height 0.5s;
  }
`
